// Report: members / subscribers whose subscription expires within the next month.
// Data comes from the backend endpoint GET /v1/bo/expiring-subscribers
// (see backoffice.routes.js -> models.subscriptions.getExpiringSubscribers).
let expiringSubscribersSection = {
  name: "Member Akan Expired",
  slug: "expiringSubscribers",
  visible: true,
  singularName: "expiringSubscribers",
  crud: true,
  endpoint: "/v1/bo/expiring-subscribers",
  updateLabel: "expiringSubscribers",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Nama",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        return row.name ? row.name : "-";
      },
    },
    {
      label: "Username",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        return row.username ? "@" + row.username : "-";
      },
    },
    {
      label: "Email",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        return row.email ? row.email : "-";
      },
    },
    {
      label: "No. HP",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        return row.phone ? row.phone : "-";
      },
    },
    {
      label: "Tgl Expired",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        return row.expires_at ? row.expires_at : "-";
      },
    },
    {
      label: "Sisa Hari",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        const d = parseInt(row.days_left);
        if (isNaN(d)) return "-";
        return d <= 0 ? "Hari ini" : `${d} hari lagi`;
      },
    },
  ],
};

export default [expiringSubscribersSection];
